import * as firebase from 'firebase';

export const reference = (path = null) => {
  if (path) {
    return firebase.database().ref(path);
  }
  return firebase.database().ref();
};
